export class LocalStorageConstants {

    public static AccessToken : string = "AccessToken";
    public static Country: string = "Country";
    public static Langs: string = "Langs";
    public static CurrentLang: string = "CurrentLang";
  }
  